module.exports = __webpack_public_path__ + "img/bookings2.2184469d.png";